import { createKeyFactory } from '@clouway/query'

export const networksKeys = createKeyFactory('networks')

export const networksListKey = () => networksKeys.list()

export const networkDetailKey = (id: string) => networksKeys.detail(id)
